<template>
    <section class="record-item">
        <div class="record-container">
            <div class="record-top-bar">
                <div class="bar-in"></div>
            </div>
            <div class="container-content">
                <div class="record" v-for="(item,index) in trackings" :key="index">
                    <div class="point" :class="{pointon: index === 0}">
                        <img v-if="NodeIcon[item[0].stage]" :src="NodeIcon[item[0].stage].normalUrl">
                    </div>
                    <div class="text" :class="{texton: index === 0}">
                        <p v-if="NodeIcon[item[0].stage]" class="main-node">{{NodeIcon[item[0].stage].name}}</p>
                        <div v-for="(node, dindex) in item" :key='dindex'>
                            <div class="node-accepttime">
                                <p class="accepttime-time">{{node.acceptTime.split(' ')[1]}}</p>
                                <p class="accepttime-date">{{node.acceptTime.split(' ')[0]}}</p>
                            </div>
                            <div class="normal-point"></div>
                            <p class="node-remark" v-if="node.nodeDesc !== node.remark">{{node.remark}}</p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="record-map" v-if="polylinePath && polylinePath.length > 0">
            <locus-map :stage="stage" :polylinePath="polylinePath" :trackings="trackings"></locus-map>
        </div>
    </section>
</template>

<script>
import locusMap from './map/mMap';
export default {
    props: {
        polylinePath: Array,
        stage: String,
        trackings: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    components: {
        locusMap
    },
    data() {
        return {
            that: this,
            NodeIcon: {
                'SIGN': {
                    name: '已签收',
                    normalUrl: require('../../images/icon/order-icon/svg/stage_signed_in.svg')
                },
                'DISTRIBUTING': {
                    name: '派送中',
                    normalUrl: require('../../images/icon/order-icon/svg/stage_delivery.svg')
                },
                'TRANSPORT': {
                    name: '运输中',
                    normalUrl: require('../../images/icon/order-icon/svg/stage_transit.svg')
                },
                'TASK': {
                    name: '仓库作业',
                    normalUrl: require('../../images/icon/order-icon/svg/stage_warehouse_operation.svg')
                },
                'DISPATCH': {
                    name: '排车调度',
                    normalUrl: require('../../images/icon/order-icon/svg/stage_vehicle_scheduling.svg')
                },
                'ORDER': {
                    name: '订单处理',
                    normalUrl: require('../../images/icon/order-icon/svg/stage_order_processing.svg')
                }
            }
        };
    },
};
</script>

<style lang="less">
.record-item {
    display: flex;
    width: 100%;
    height: 6rem;
    .record-container {
        flex: 1;
        flex-shrink: 0;
        overflow-y: scroll;
        margin-top: .2rem;
    }
    .container-content {
        border-left: #DADADA solid 0.02rem;
        margin-left: 1.12rem;
        padding-left: .22rem;
        box-sizing: border-box;
        margin-right: .1rem;
        padding-bottom: 0.01rem;
    }
    .record {
        line-height: 2em;
        position: relative;
        font-size: 12px;
    }
    .point {
        position: absolute;
        left: -0.36rem;
        background: #999999;
        border-radius: 50%;
        height: 0.26rem;
        width: 0.26rem;
        img {
            display: block;
            height: 15px;
            width: 15px;
            margin: .05rem auto;
        }
    }
    .pointon {
        background: #4285f5;
    }
    .normal-point {
        position: relative;
        left: -0.3rem;
        height: 0.05rem;
        width: 0.05rem;
        background: #333333;
        border-radius: 50%;
        border: 0.05rem solid rgba(230, 230, 230);
    }
    .text {
        margin-bottom: 0.1rem;
        color: #666;
        .main-node {
            margin-bottom: .3rem;
            font-weight: 500;
            color: #333333;
        }
    }
    .texton {
        .main-node {
            color: #4285f5;
        }
    }
    .node-remark {
        margin-bottom: .05rem;
        position: relative;
        top: -0.19rem;
    }
    .node-accepttime {
        position: absolute;
        left: -1.14rem;
        text-align: right;
        margin-top: -0.06rem;
    }
    .accepttime-time {
        color: #333333;
        font-weight: 500;
        line-height: 1;
    }
    .accepttime-date {
        color: #888888;
    }
    .record-map {
        flex: 1;
        width: 100%;
        height: 100%;
        background-color: antiquewhite;
    }
    .record-top-bar {
        display: none;
    }
}

@media screen and (max-width: 480px) {
    .record-item {
        height: calc(100vh - 2.4rem);
        .record {
            line-height: 0.28rem;
            display: block;
            position: relative;
        }
        .point {
            left: -0.35rem;
            img {
                width: 0.3rem;
            }
        }
        .pointon {
            left: -0.35rem;
            background: #4285f5;
        }
        .text {
            margin-bottom: 0.15rem;
            color: #666666;
            .main-node {
                margin-bottom: .15rem;
            }
        }
        .node-remark {
            font-size: 14px;
            margin-bottom: .15rem;
        }
        .node-accepttime {
            font-size: 12px;
        }
        .record-map {
            width: 100%;
            height: calc(100vh - 2.4rem);
        }
        .record-container {
            position: absolute;
            z-index: 2;
            background: #fff;
            width: 100%;
            top: 5.75rem;
            box-shadow: #999999 0px 0px 0.05rem;
            margin: 0;
            height: calc(100vh - 5.75rem);
            overflow-y: hidden;
            transition: all .3s ease;
        }
        .record-top-bar {
            display: block;
            padding: 0.1rem 0 0.15rem 0;
            .bar-in {
                width: .3rem;
                height: .04rem;
                background: #999999;
                border-radius: 3px;
                margin: 0 auto;
            }
        }
    }
}
</style>